import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { DOC_REVIEW_DASHBOARD_PATH } from 'docReviewDashboard'

import AddCannedMessages from './addCannedMessages/addCannedMessages'
import ViewCannedMessages from './viewCannedMessages/viewCannedMessages'

export const CANNED_MESSAGES_PATH = 'canned-messages'

const CannedMessages: React.FC = () => {
  return (
    <Switch>
      <Route exact path={`${DOC_REVIEW_DASHBOARD_PATH}/${CANNED_MESSAGES_PATH}/add`} component={AddCannedMessages} />
      <Route exact path="/doc-review-dashboard/canned-messages/:cannedMessageId" component={AddCannedMessages} />
      <Route path="/" component={ViewCannedMessages} />
    </Switch>
  )
}

export default CannedMessages
